import { render } from "./UserLayout.vue?vue&type=template&id=49a644b0&scoped=true"
const script = {}

import "./UserLayout.vue?vue&type=style&index=0&id=49a644b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a644b0"]])

export default __exports__